import { isThreadBusy, type ThreadExecutionEvidence } from "./threadExecution.ts";

/** Request acknowledgement is not completion; only native evidence or explicit recovery settles it. */
export function isManualCompactionInFlight(
  activities: ReadonlyArray<{ readonly kind: string }>,
): boolean {
  for (let index = activities.length - 1; index >= 0; index--) {
    const kind = activities[index]?.kind;
    if (kind === "context-compaction.requested") return true;
    if (
      kind === "context-compaction" ||
      kind === "context-compaction.failed" ||
      kind === "context-compaction.interrupted"
    )
      return false;
  }
  return false;
}

export function canRequestManualCompaction(
  evidence: ThreadExecutionEvidence & {
    readonly activities: ReadonlyArray<{ readonly kind: string }>;
    readonly hasMessages?: boolean;
  },
): boolean {
  return (
    (evidence.sessionStatus === "ready" ||
      (evidence.sessionStatus == null &&
        evidence.latestTurnState == null &&
        evidence.hasMessages === false)) &&
    !isThreadBusy(evidence) &&
    !isManualCompactionInFlight(evidence.activities)
  );
}
